import Switch from "react-switch";
import styled, { useTheme } from "styled-components";
import { Subhead } from "../../../styles/typography";

const SwitchRow = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

const SwitchLabel = styled(Subhead)`
  color: rgb(${(props) => props.theme.colors.neutral400});
  font-weight: 600;
`;

/**
 * react-switch only accepts hex colors, theme stores "r,g,b" channel strings
 * @param {string} channels
 */
const toHex = (channels) =>
  `#${channels
    .split(",")
    .slice(0, 3)
    .map((c) => Number(c).toString(16).padStart(2, "0"))
    .join("")}`;

/**
 * @param {{checked: boolean, onChange: (checked: boolean) => void}} props
 */
const ReorderToggle = ({ checked, onChange }) => {
  const theme = useTheme();
  return (
    <SwitchRow>
      <SwitchLabel>Reorder chapters</SwitchLabel>
      <Switch
        checked={checked}
        onChange={onChange}
        onColor={toHex(theme.colors.neutral600)}
        offColor={toHex(theme.colors.neutral150)}
        checkedIcon={false}
        uncheckedIcon={false}
        height={28}
        width={50}
        handleDiameter={22}
      />
    </SwitchRow>
  );
};

export default ReorderToggle;
